const commonData = {
    event_type: 'load',
};
const getDataForProductView = (data = {}) => {
    var _a;
    const product = data.product || {};
    return Object.assign(Object.assign({}, commonData), { page_type: 'product', page_name: product.name, page_id: product.id, page_url: (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.href, product_id: product.childId || product.id, product_sku: product.sku, product_name: product.name, product_brand: product.brandName, product_mrp: product.mrp, product_dp: product.offerPrice, product_currency: product.currency, page_frequency: 1 });
};
const getDataForOfferListingView = (data = {}) => {
    var _a;
    const { pageId = '' } = data;
    return Object.assign(Object.assign({}, commonData), { page_frequency: 1, page_id: pageId, page_type: 'offer_listing', page_name: 'offer', page_url: (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.href });
};
const getDataForCategoryView = (data = {}) => {
    var _a;
    const { category = {}, listingPageType = '', dnHybridPageType = '' } = data;
    return Object.assign(Object.assign({}, commonData), { page_frequency: 1, page_id: category.id, page_type: `${listingPageType}_listing`, page_name: category.name, page_url: (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.href, hybrid_page_type: dnHybridPageType });
};
const getDataForHomeView = (data = {}) => {
    var _a;
    const { widgetsPageType = '' } = data;
    return Object.assign(Object.assign({}, commonData), { page_frequency: 1, page_id: widgetsPageType, page_type: 'landing', page_name: 'home', page_url: (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.href });
};
const getDataForNLPView = (data = {}) => {
    var _a;
    const { widgetsPageType = '', pageName = '' } = data;
    return Object.assign(Object.assign({}, commonData), { page_frequency: 1, page_id: widgetsPageType, page_type: 'landing', page_name: pageName, page_url: (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.href });
};
const getDataForCMSView = (data = {}) => {
    var _a;
    const { pageName = '', pageType = '' } = data;
    return Object.assign(Object.assign({}, commonData), { page_frequency: 1, page_id: pageName, page_type: 'landing', page_name: pageType, page_url: (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.href });
};
const getDataForSearchView = (data = {}) => {
    var _a;
    const { searchListing = {}, dnHybridPageType = '' } = data;
    return Object.assign(Object.assign({}, commonData), { page_frequency: 1, page_id: searchListing.searchTerm, page_type: 'search_listing', page_name: searchListing.searchTerm, page_url: (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.href, hybrid_page_type: dnHybridPageType });
};
const dataLayerUtils = {
    getDataForProductView,
    getDataForCategoryView,
    getDataForHomeView,
    getDataForCMSView,
    getDataForNLPView,
    getDataForSearchView,
    getDataForOfferListingView,
};
export default dataLayerUtils;
